/* ===========================================================================
   RESET — affirmative consent capture.   BUILT 2026-09-07. NOT SHIPPED.
   Specification: briefs/output/legal/consent-claims-escalation-2026-09-06.md §F-2
   Covers BOTH customer forms: the footer newsletter and the homepage RESET CLUB
   banner. Shipping one without the other would leave the enforcer revoking
   consent for signups from the uncovered surface.
   ===========================================================================

   WHY THIS FILE EXISTS
   --------------------
   `{% form 'customer' %}` sets accepts_marketing = true on ANY submission,
   regardless of what the visitor ticked — or, on the club banner until today,
   with no checkbox on the page at all. Shopify also silently DISCARDS any field
   name it does not recognise, so naming the checkboxes creates no record. The
   consequence is that RESET holds affirmative marketing-consent records it
   cannot substantiate.

   WHAT THIS FILE IS AND IS NOT
   ----------------------------
   This is the CLIENT half: a UX gate and a record BUILDER. It is NOT the
   enforcement boundary. Anything in the browser can be bypassed — a direct
   form.submit() call skips both native validation and the submit event
   entirely — so a consent record that only a script guarantees is not evidence.
   The boundary is the fail-closed customers webhook consumer
   (whatsapp-bot/bot/consent_enforcer.py), which clears marketing consent from
   any customer arriving without a versioned consent tag.

   MULTI-FORM SAFETY
   -----------------
   Both forms render on the homepage, so the checkboxes are located by
   data-attribute WITHIN each form, never by a document-wide id lookup. The ids
   still exist and are unique per form, because <label for> needs them — but
   nothing in this file resolves an id globally.

   WORDING IS FROZEN. This file reads the consent strings; it never renders or
   alters them. Both forms are configured with byte-identical strings.
   consentVersion must be bumped by hand whenever that wording changes — that
   version is what ties a stored record to the exact text a person was shown,
   and it is the only thing that makes the record evidence rather than a claim.

   NOT SENT, DELIBERATELY
   ----------------------
   - subscriptions.sms.*  Never, on either form. The club banner DOES collect an
     optional phone, but no affirmative SMS consent is captured for it and
     counsel has flagged the bundled email+SMS wording as a §30א risk. Asserting
     SMS consent RESET cannot defend is worse than capturing none.
   - the phone number itself. Not sent to Klaviyo by this file.
   - IP address. Personal data; the Privacy Policy does not disclose it.
   =========================================================================== */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }

  function tagsFor(version, terms, marketing) {
    // contact[tags] is the ONLY field on {% form 'customer' %} that persists.
    // The version suffix is load-bearing: "consent_marketing" alone proves
    // nothing about WHAT was agreed to.
    var v = String(version || '').replace(/-/g, '');
    var tags = [];
    if (terms)     tags.push('consent_terms_v' + v);
    if (marketing) tags.push('consent_marketing_email_v' + v);
    return tags;
  }

  function payload(cfg, email) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                      consented_at: new Date().toISOString()
                    }
                  }
                },
                properties: {
                  consent_text_version:       cfg.version,
                  consent_terms_accepted:     true,
                  consent_marketing_accepted: true,
                  consent_method:             cfg.method,
                  consent_source_url:         window.location.href.split('#')[0]
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: cfg.listId } }
        }
      }
    };
  }

  function bind(wrap) {
    var form = $('form', wrap);
    if (!form || form.dataset.rsConsentBound) return;

    var terms     = $('[data-rs-consent-terms]', form);
    var marketing = $('[data-rs-consent-marketing]', form);
    var email     = $('input[type=email]', form);
    var tagsField = $('input[name="contact[tags]"]', form);
    if (!terms || !marketing || !email || !tagsField) return;

    var cfg = {
      version: wrap.getAttribute('data-consent-version') || '',
      method:  wrap.getAttribute('data-consent-method')  || 'unknown',
      source:  wrap.getAttribute('data-consent-source')  || 'getreset.co.il',
      companyId: (window.RS_CONSENT || {}).companyId || '',
      listId:    (window.RS_CONSENT || {}).listId    || ''
    };
    if (!cfg.companyId || !cfg.listId || !cfg.version) return;

    form.dataset.rsConsentBound = '1';

    form.addEventListener('submit', function (e) {
      // The gate cannot live in the markup: Shopify records consent on ANY
      // submission, so the only way to stop an unticked box producing a consent
      // record is to stop the submission.
      if (!terms.checked || !marketing.checked) {
        e.preventDefault();
        e.stopPropagation();
        [terms, marketing].forEach(function (cb) {
          cb.setAttribute('aria-invalid', cb.checked ? 'false' : 'true');
        });
        (terms.checked ? marketing : terms).focus();
        return;
      }
      terms.setAttribute('aria-invalid', 'false');
      marketing.setAttribute('aria-invalid', 'false');

      // Merge, never overwrite: the club form ships with "newsletter,club"
      // already in this field and dropping those would be a regression in the
      // only durable record Shopify keeps.
      var existing = (tagsField.value || '').split(',')
        .map(function (t) { return t.trim(); }).filter(Boolean);
      tagsFor(cfg.version, terms.checked, marketing.checked).forEach(function (t) {
        if (existing.indexOf(t) === -1) existing.push(t);
      });
      tagsField.value = existing.join(',');

      var value = (email.value || '').trim();
      if (!value) return;

      // Klaviyo is the authoritative consent store. keepalive lets the request
      // survive the navigation Shopify triggers; we never block the submit on it.
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' +
              encodeURIComponent(cfg.companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(payload(cfg, value)),
          keepalive: true,
          mode: 'cors'
        }).catch(function () { /* never block the submit on this */ });
      } catch (err) { /* no-op */ }
    });
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-rs-consent]'), bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
